import styled from '@emotion/styled';

interface DropDownProps {
  children: React.ReactNode;
  label: any;
  className?: string;
}

const DropDownTemplate: React.FC<DropDownProps> = ({
  label,
  children,
  className,
}) => {
  return (
    <DropDownContainer>
      <DropDownLabel>{label}</DropDownLabel>
      <DropDownContentWrapper className='dropDownContent'>
        <ClearSpace className={className}></ClearSpace>
        <DropdownContent>{children}</DropdownContent>
      </DropDownContentWrapper>
    </DropDownContainer>
  );
};

export const HoverDropDown: React.FC<DropDownProps> = (props) => {
  return <DropDownTemplate {...props} />;
};

const DropDownContainer = styled.div`
  position: relative;
  /* border: 1px solid blue; */

  &:hover > div.dropDownContent {
    opacity: 1;
    pointer-events: auto;
  }
`;

const DropDownLabel = styled.div`
  display: flex;
  align-items: center;
`;

const DropDownContentWrapper = styled.div`
  position: absolute;
  width: fit-content;
  overflow: hidden;
  right: -12px;
  top: 10%;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease-in-out;
  z-index: 5;
  min-width: 100%;
  display: flex;
  flex-direction: column;
  /* border: 1px solid red; */
  padding: 12px;
  /* border-radius: 10px; */
  /* background-color: transparent; */
`;

const DropdownContent = styled.div`
  /* border: 1px solid ${({ theme }) => theme.palette.borderColor}; */
  border-radius: 10px;
  width: fit-content;
  overflow: hidden;
  background-color: white;
  box-shadow: 1px 4px 12px -1px #2c4e2726;

  /* border: 1px solid blue; */
`;

const ClearSpace = styled.div`
  display: flex;
  height: 24px;

  &.biggerClearance {
    height: 40px;
  }
`;
